<template>
  <router-link :to="resolveRoute">
    <div class="content-card add-pointer">
      <progressive-img class="image" :aspect-ratio="0.80" :src="item.previewUrl" :placeholder="placeholder" :fallback="placeholder" :alt="item.description"/>
      <div class="button-container">
        <button class="btn-content-details add-pointer uk-text-uppercase uk-text-bold">{{$t('general.details')}}</button>
      </div>
      <div class="item-details"></div>
      <div class="item-footer">
        <div class="content-title uk-text-truncate">{{item.title}}</div>
        <div v-if="!isAuthorEmptyOrNil(item.author)" class="content-author uk-text-truncate">{{$t('general.sharedBy')}}:
          {{item.author}}
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>
  import Router from '../../../router/index'

  export default {
    name: 'category-card',
    props: ['item'],
    data() {
      return {
        placeholder: '/static/custom-icons/search-error-image.svg'
      }
    },
    methods: {
      preview(contentId) {
        Router.push('preview/' + contentId)
      },
      isAuthorEmptyOrNil(author) {
        if (author === '<nil>' || null) {
          return true
        }
      }
    },
    computed: {
      resolveRoute() {
        return {path: 'preview/' + this.item.contentId}
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../../styles/breakpoints';
  @import '../../../styles/colours';

  a {
    &:hover {
      text-decoration: none;
      font-weight: normal;
    }
  }

  .button-container {
    position: absolute;
    height: calc(100% - 38px);
    width: 100%;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .btn-content-details {
    visibility: hidden;
    min-width: 86px;
    height: 30px;
    background-color: Transparent;
    border-radius: 2px;
    border: solid 1px #f2f2f2;
    color: white;
    z-index: 2;
  }

  .content-author {
    margin-top: 5px;
    margin-left: 9px;
    font-size: 10px;
    padding-bottom: 5px;
  }

  .content-card {
    margin-top: 12px;
    position: relative;
    border-radius: 2.6px;
    margin-bottom: 10px;
    min-height: 102px;
    min-width: 122px;
    max-height: 192px;
    max-width: 227.5px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.24);
    color: $content-text;

    &:hover {
      box-shadow: 2px 4px 8px 0 rgba(0, 0, 0, 0.24);

      .item-details {
        z-index: 1;
        background-color: rgba(0, 0, 0, 0.95);
        opacity: 0.8;
      }

      .btn-content-details {
        visibility: visible;
      }
    }
  }

  .content-title {
    margin-top: 6px;
    margin-left: 6px;
    font-size: 12px;
  }

  .image {
    border-radius: 2.6px;
    width: 100%;
    height: 100%;
  }

  .item-details {
    position: absolute;
    height: calc(100% - 38px);
    width: 100%;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top-left-radius: 2.6px;
    border-top-right-radius: 2.6px;
  }

  .item-footer {
    position: absolute;
    height: 38px;
    width: 100%;
    bottom: 0;
    background-color: $lighter-grey;
    border-bottom-left-radius: 2.6px;
    border-bottom-right-radius: 2.6px;
    z-index: 1;
  }

  @media screen and (max-width: $breakpoint-large) {
    .content-card {
      margin-top: 8px;
    }
  }

  @media screen and (max-width: $breakpoint-xlarge) {
    .content-card {
      margin-top: 10px;
    }
  }

  @media screen and (min-width: $breakpoint-small) {
    .button-container {
      height: calc(100% - 50px);
    }

    .content-title {
      font-size: 14px;
      margin-left: 9px;
      margin-top: 9px;
    }

    .item-details {
      height: calc(100% - 50px);
    }

    .item-footer {
      height: 50px;
    }
  }
</style>
